import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceLow"><Path d="M8.5 18H7V6H8.5V18Z" fill="currentColor"/><Path d="M17 16H15.5V8H17V16Z" fill="currentColor"/><Path d="M12.75 14H11.25V10H12.75V14Z" fill="currentColor"/><Path d="M4.5 13.5H3V10.5H4.5V13.5Z" fill="currentColor"/><Path d="M21 13.5H19.5V10.5H21V13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceLow;
